import { render } from "./supplier.vue?vue&type=template&id=0df789de&scoped=true&ts=true"
import script from "./supplier.vue?vue&type=script&lang=ts"
export * from "./supplier.vue?vue&type=script&lang=ts"

import "./supplier.vue?vue&type=style&index=0&id=0df789de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df789de"]])

export default __exports__